module.exports = __webpack_public_path__ + "static/map-6b0b2de393bfc719f40af21031b70847.svg";